import { Calendar } from "app/components/Calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover/index";
import clsx from "clsx";
import React, { FC } from "react";
import { dateFormatter } from "utils/helpers";

interface DatePickerProps {
  label?: string;
  value: Date | null;
  onChange: (date: Date) => void;
  disabled?: boolean;
  className?: string;
  error?: string;
  align?: "start" | "center" | "end";
  minDate?: Date | null;
  maxDate?: Date | null;
  openProp?: boolean;
  setOpen?: (open: boolean) => void;
  mode: "add" | "edit";
}

export const DatePicker: FC<DatePickerProps> = ({
  label,
  value = new Date(),
  onChange,
  disabled,
  className,
  error,
  align = "start",
  minDate,
  maxDate,
  openProp,
  setOpen,
  mode,
}) => {
  // Local States
  const [open, setOpenState] = React.useState(openProp ?? false);

  return (
    <Popover
      open={open}
      onOpenChange={(open) => {
        if (setOpen) setOpen(open);
        setOpenState(open);
      }}
    >
      <PopoverTrigger asChild>
        <div className="w-fit">
          <button
            disabled={disabled}
            className={clsx(
              "flex items-center justify-between text-sm leading-none gap-2 flex-row border rounded px-3 py-2.5 text-nowrap bg-white hover:bg-gray-400",
              open ? "!border-secondary" : "border-gray-100",
              error && "border-danger",
              disabled && "opacity-50",
              mode === "edit" && "!px-[7px] !py-[8px] text-xs",
              className,
            )}
          >
            {dateFormatter(value ?? new Date(), "onlyDate")}
          </button>

          {error && (
            <span className="text-[11px] leading-[18px] text-danger absolute bottom-[-18px]">
              {error}
            </span>
          )}
        </div>
      </PopoverTrigger>

      <PopoverContent
        align={align}
        className={`w-[222.798px] !px-4 !py-3 bg-white border border-gray-100`}
      >
        <Calendar
          mode="single"
          selected={value ? new Date(value) : undefined}
          onSelect={(val) => {
            onChange(val);
          }}
          required={true}
          disabled={(date: Date) => {
            if (minDate && date < minDate) return true;
            if (maxDate && date > maxDate) return true;
            return false;
          }}
        />
      </PopoverContent>
    </Popover>
  );
};
